import { Stack, styled, Typography, type CSSObject } from '@mui/material';

export const CostOfInformationChaosWrapper = styled(Stack)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export const CostOfInformationChaosRowWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(0.75),
  alignItems: 'flex-start',
}));

export const CostOfInformationChaosPoint = styled(Stack)(({ theme }) => ({
  height: theme.spacing(1.5),
  width: theme.spacing(1.5),
  minHeight: theme.spacing(1.5),
  minWidth: theme.spacing(1.5),
  ...(theme.mixins.cyanGradient as CSSObject),
  borderRadius: theme.spacing(10),
  marginTop: theme.spacing(1.2),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(1.5),
    height: theme.spacing(1),
    width: theme.spacing(1),
    minHeight: theme.spacing(1),
    minWidth: theme.spacing(1),
  },
}));
